<template>
    <div>
   <nav-bar-main></nav-bar-main>

        <!-------------------------------------------------------------->     
        <!-- Show banner to upgrade a pro in centralized basic system -->
        <!-------------------------------------------------------------->
        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic' && this.$store.getters.isCentralized" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        
        <!-------------------------------------------------------------->     
        <!-- Show banner to upgrade a pro if expired pro code ---------->
        <!-------------------------------------------------------------->
        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>

        <!-------------------------------------------------------------->     
        <!-- Manage pending invites ------------------------------------>
        <!-------------------------------------------------------------->
        <b-alert v-if="invitoPendente != null" show variant="success" style="display:inline-block;width:100%">
            <span v-html="$t('home.accetta_invito_pendente_message',{dataInvito: moment(invitoPendente.dateRequest,).format('DD/MM/YYYY'), impianto: invitoPendente.plantName })"></span>
            <b-button @click="accettaInvitoPendente" variant="primary" style="float: right">ACCETTA INVITO</b-button>
        </b-alert>

        <!-------------------------------------------------------------->     
        <!-- Show warning snackbar in case of error -------------------->
        <!-------------------------------------------------------------->
        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>
        <Loader />
        <div  v-if="plantDetails != null" class="homeImpiantoMainContent animated fadeIn container-fluid ">
        
        <!-------------------------------------------------------------->     
        <!--  Start overview dashboard page ---------------------------->
        <!-------------------------------------------------------------->    
             <!-- Overview First Row -->
             <b-row  class="mt-4 ml-3 mr-3">
                
                <!-- Plant Google Map -->
                <b-col  xl="4" lg="4" class="mt-3 mapcol">
                    <div class="embed-responsive embed-responsive-4by3 home-widget radius-card h-100">
                        <plant-map/>
                    </div>    
                </b-col>

                <!--- Graph Donut Bluetooth system without gateway -->
                <b-col v-if="this.$store.getters.isBluetooth && !this.$store.getters.isCentralized" xl="4" lg="4" class="mt-1">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100 ">       
                        
                        <div v-if="plantDetails.controlunits.length==0"  class="card-title text-center p-1 mb-4">{{this.$t('bluetooth.donut_title')}}</div>   
                        
                            <b-row>
                                <b-col sm="12" md="" lg="12" xl="12">   
                                    <grafico-donut v-if="errorGraphLampBle != null" :graphData="errorGraphLampBle"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numLampsBleOk>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsBleOk}}</p><p  class="text-justify mt-1">{{this.$t("pass")}}</p>
                                    </div>
                                    <div v-if="(this.totalLampsBle- this.numLampsBleOk)>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold mr-1">{{this.totalLampsBle- this.numLampsBleOk}}</p><p  class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div  v-if="this.totalLampsBle>0" class="d-flex justify-content-center mt-4">
                                        <p class="text-justify">{{this.$t("bluetooth.last_sync") + ' : '}}</p><p class="text-justify ml-1">{{getLastSync()}}</p>
                                    </div>
                                </b-col>
                            </b-row>
                  </b-card> 
                </b-col>

                  
                <!--- Graph Donut in centralized system -->
                <b-col v-else xl="4" lg="4" class="mt-3">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100">       
                        <!-- <b-tabs card lazy class="home-widget text-widget h-100">-->
                        <Tabs>   
                            
                        <!--- PLANT STATUS - Donut Control units and devices -->   
                        <TabItem :name="this.$t('graph.donut-title')" class="p-5">          

                            <b-row>
                                <!--- Graph Donut control units -->
                                <b-col sm="12" md="6" lg="6" xl="6">    
                                    <grafico-donut v-if="errorGraphCent != null" :graphData="errorGraphCent"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numUnitsOk>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold mr-1 text-justify">{{this.numUnitsOk}}</p><p class="text-justify mt-1">online</p>
                                    </div>
                                    <div v-if="this.numUnitsFail>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold mr-1 text-justify">{{this.numUnitsFail}}</p><p class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div v-if="this.numUnitsDisconnected>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#E3E6E7"></i>
                                        <p class="text-widget-bold mr-1 text-justify">{{this.numUnitsDisconnected}}</p><p class="text-justify mt-1">{{this.$t("disconnected")}}</p>
                                    </div>
                                </b-col>

                                <!--- Graph Donut all devices -->
                                <b-col sm="12" md="" lg="6" xl="6">   
                                    <grafico-donut v-if="errorGraphLamp != null" :graphData="errorGraphLamp"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numLampsOk>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsOk}}</p><p  class="text-justify mt-1">{{this.$t("pass")}}</p>
                                    </div>
                                    <div v-if="this.numLampsFail>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold mr-1">{{this.numLampsFail}}</p><p  class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div v-if="this.numLampsDisconnected>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2 ml-2" style="color:#E3E6E7"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsDisconnected}}</p><p class="text-justify mt-1">{{this.$t("disconnected")}}</p>
                                    </div>
                                    <div v-if="this.numLampsOrphan>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#EE82EE"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsOrphan}}</p><p class="text-justify mt-1">{{this.$t("details_cu_modal.orphan")}}</p>
                                    </div>
                                    <div v-if="this.numLampsBleNoGateway.all>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2 ml-4" style="color:#04709C"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsBleNoGateway.all}}</p><p class="text-justify mt-1">{{this.$t("bluetooth_no_gateway")}}</p><i class="fa fa-bluetooth mt-2 mr-2" style="color:#04709C"></i>
                                    </div>
                                </b-col>
                            </b-row>

                        </TabItem>
                        
                        <!--- LAMPS - Donut lampade illuminazione e emergenza -->  
                        <TabItem :name="this.$t('lamps')" class="p-5">          
                            <b-row>
                               <b-col sm="12" md="" lg="6" xl="6">   
                                    <grafico-donut v-if="errorGraphIllum!= null" :graphData="errorGraphIllum"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numIllumPass>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numIllumPass}}</p><p class="text-justify mt-1">{{this.$t("pass")}}</p>
                                    </div>
                                    <div v-if="this.numIllumFail>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numIllumFail}}</p><p  class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div v-if="this.numIllumOrphan>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#EE82EE"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numIllumOrphan}}</p><p class="text-justify mt-1">{{this.$t("details_cu_modal.orphan")}}</p>
                                    </div>
                                    <div v-if="this.numIllumDisconnected>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#E3E6E7"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numIllumDisconnected}}</p><p  class="text-justify mt-1">{{this.$t("disconnected")}}</p>
                                    </div>
                                    <div v-if="this.numLampsBleNoGateway.ordinary>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2 ml-4" style="color:#04709C"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsBleNoGateway.ordinary}}</p><p class="text-justify mt-1">{{this.$t("bluetooth_no_gateway")}}</p><i class="fa fa-bluetooth mt-2 mr-2" style="color:#04709C"></i>
                                    </div>
                                </b-col>
                                <b-col sm="12" md="" lg="6" xl="6">   
                                    <grafico-donut v-if="errorGraphEmergency!= null" :graphData="errorGraphEmergency"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numEmergencyPass>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numEmergencyPass}}</p><p class="text-justify mt-1">{{this.$t("pass")}}</p>
                                    </div>
                                    <div v-if="this.numEmergencyFail>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numEmergencyFail}}</p><p class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div v-if="this.numEmergencyOrphan>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#EE82EE"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numEmergencyOrphan}}</p><p class="text-justify mt-1">{{this.$t("details_cu_modal.orphan")}}</p>
                                    </div>
                                    <div v-if="this.numEmergencyDisconnected>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#E3E6E7"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numEmergencyDisconnected}}</p><p class="text-justify mt-1">{{this.$t("disconnected")}}</p>
                                    </div>
                                    <div v-if="this.numLampsBleNoGateway.emergency>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2 ml-4" style="color:#04709C"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numLampsBleNoGateway.emergency}}</p><p class="text-justify mt-1">{{this.$t("bluetooth_no_gateway")}}</p><i class="fa fa-bluetooth mt-2 mr-2" style="color:#04709C"></i>
                                    </div>
                                </b-col>
                            </b-row>
                        </TabItem>

                        <!--- OTHER DEVICES - Donut altri dispositivi -->  
                        <TabItem :name="this.$t('other_devices')" class="p-5">          
                            <!--- Donut sensori -->  
                            <b-row>
                                <b-col sm="12" md="" lg="12" xl="12">   
                                    <grafico-donut v-if="errorGraphSensori != null" :graphData="errorGraphSensori"/>
                                    <div class="mt-4"></div>
                                    <div v-if="this.numSensorPass>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#29CC96"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numSensorPass}}</p><p class="text-justify mt-1">{{this.$t("pass")}}</p>
                                    </div>
                                    <div v-if="this.numSensorFail>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#F03040"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numSensorFail}}</p><p class="text-justify mt-1">{{this.$t("fail")}}</p>
                                    </div>
                                    <div v-if="this.numSensorDisconnected>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#E3E6E7"></i>
                                        <p class="text-widget-bold  mr-1">{{this.numSensorDisconnected}}</p><p class="text-justify mt-1">{{this.$t("disconnected")}}</p>
                                    </div>
                                    <div v-if="this.numSensorOrphan>0" class="d-flex justify-content-center">
                                        <i class="fa fa-minus mt-2 mr-2" style="color:#EE82EE"></i>
                                        <p class="text-widget-bold mr-1">{{this.numSensorOrphan}}</p><p class="text-justify mt-1">{{this.$t("details_cu_modal.orphan")}}</p>
                                    </div>
                                </b-col>
                            </b-row>

                         </TabItem>
                        </Tabs>  
                  </b-card> 
                </b-col>

                <!-- Logbooks bluetooth -->    
                <b-col v-if="this.bleLogbooks!=null && this.$store.getters.isBluetooth && !this.$store.getters.isCentralized" xl="4" lg="4" class="mt-1">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100">                           
                        <div class="card-title text-center p-1 mb-4">{{this.$t('bluetooth.report_title')}}</div>   
                            <b-row class="p-3">
                            <report-ble-overview></report-ble-overview>
                            </b-row>
                  </b-card> 
                </b-col>


                <!-- Alert Centralizzato -->    
                <b-col  v-if="errorGraphIllum!= null && this.totalIllum==0  && this.$store.getters.isCentralized" xl="4" lg="4" class="mt-3">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100"> 
                        <Tabs card lazy >
                            <TabItem :name="$t('cards.title_alarm')" class="pt-4 pl-4 pr-4">
                                <alert-overview/>
                            </TabItem>
                        </Tabs>
                    </b-card>
                </b-col>

                <!-- Energy and Report ambientali centralizzato -->
                <b-col  v-if="errorGraphIllum!= null && this.totalIllum>0 && plantDetails.controlunits.length>0" xl="4" lg="4" class="mt-3">
                    <b-card  class="home-widget text-widget bg-secondary radius-card h-100"> 
                        <Tabs card lazy >
                            <TabItem :name="$t('energy.energy_saving')" class="pt-5 pl-4 pr-4">
                                <grafico-donut-energy v-if="energyGraph != null" :graphData="energyGraph"/>
                                    <b-row class="justify-content-center">
                                    <b-col cols="9">
                                    <div class="d-flex justify-content-left mt-4">
                                        <i class="fa fa-minus mt-1 ml-5 mr-2" style="color:orange"></i>
                                        <p class="typo-title">{{$t('energy.energy_consumed')}}: <strong>{{(Math.round(this.plant_energia_consumata)).toLocaleString('it')}} kWh</strong></p>
                                    </div>
                                    <div class="d-flex justify-content-left mt-1">
                                        <i class="fa fa-minus mt-1 ml-5 mr-2" style="color:#29CC96"></i>
                                        <p class="typo-title">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(this.plant_energia_risparmiata)).toLocaleString('it')}} kWh</strong></p>
                                    </div>
                                    <div class="d-flex justify-content-left mt-1">
                                        <i class="fa fa-clock mt-1 ml-5 mr-2" style="color:grey"></i>
                                        <p class="typo-title">{{$t('energy.hours_operation')}}: <strong>{{(Math.round(this.plant_timeon)).toLocaleString('it')}} h</strong></p>
                                    </div>
                                    </b-col>
                                    </b-row>
                            </TabItem>
                            <TabItem :name="$t('energy.environmental_benefits')"  class="pt-4 pl-4 pr-4">
                                    <b-row class="d-flex mt-5 ml-5">
                                        <b-col cols="3" >
                                            <i class="fa fa-plug fa-2x mt-1" style="color:#0090CD;"></i>
                                        </b-col>
                                        <b-col cols="8">
                                            <p class="typo-title mt-2">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(this.plant_energia_risparmiata)).toLocaleString('it')}} kWh</strong></p>
                                        </b-col>
                                    </b-row>
                                    <b-row class="d-flex  mt-4 ml-5">
                                        <b-col cols="3" >
                                            <i class="fa fa-cloud fa-2x mt-1" style="color:gray;"></i>
                                        </b-col>
                                        <b-col cols="8">
                                            <p class="typo-title mt-2">{{$t('energy.CO2')}}: <strong>{{(Math.round(this.plant_energia_risparmiata*0.5)).toLocaleString('it')}} Kg</strong></p>
                                        </b-col>    
                                    </b-row>    
                                    <b-row class="d-flex mt-4 ml-5">
                                        <b-col cols="3">
                                            <i class="fa fa-tint fa-2x mt-1 pl-2" style="color:black;"></i>
                                        </b-col>
                                        <b-col cols="8">
                                            <p class="typo-title mt-2">{{$t('energy.oil')}}: <strong>{{(this.plant_energia_risparmiata*0.000187).toFixed(2).toLocaleString('it')}}</strong></p>                                       
                                        </b-col>    
                                    </b-row>
                                    <b-row class="d-flex mt-4 ml-5">
                                        <b-col cols="3">
                                            <i class="fa fa-tree fa-2x mt-1 pl-2" style="color:green;"></i>
                                        </b-col>
                                        <b-col cols="8">
                                            <p class="typo-title mt-2">{{$t('energy.trees')}}: <strong>{{(Math.round(this.plant_energia_risparmiata/20)).toLocaleString('it')}}</strong></p>                                       
                                        </b-col>    
                                    </b-row>
                            </TabItem>
                        </Tabs>
                    </b-card>
                </b-col>
            </b-row>

            <!--- Overview Second Row -->
            <b-row v-if="plantDetails!=null && this.$store.getters.isCentralized" class="mt-4 ml-3 mr-3 mb-5" >
    
                <!-- Alert and Report Overview -->
                <b-col  xl="4" lg="4" class="mt-3">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100"> 
                        <Tabs>
                            <TabItem v-if="this.totalIllum>0" :name="$t('cards.title_alarm')" class="pt-4 pl-4 pr-4">
                                <alert-overview/>
                            </TabItem>
                            <TabItem :name="$t('cards.title_report')" class="pt-4 pl-4 pr-4">
                                <report-overview/>
                                <router-link :to="{path: '/plantreport/'+ this.$store.state.currentPlant.id}" v-if="isPro && !$store.getters.isProExpired"><b-button class="typo-label mt-5 mr-2 float-right" variant="link">{{this.$t('graph.all_report')}}</b-button></router-link>
                            </TabItem>
                            <TabItem v-if="this.bleLogbooks && this.bleLogbooks.length>0" :name="$t('cards.title_report') +' BLUETOOTH'" class="pt-4 pl-2 pr-2">
                                <report-ble-overview></report-ble-overview>
                            </TabItem>    
                        </Tabs>
                    </b-card>
                </b-col>

                <!--- Graph Storico dei test -->                
                <b-col xl="8" lg="8" class="mt-3">
                    <b-card v-if="isPro && !$store.getters.isProExpired" class="home-widget bg-secondary text-widget radius-card h-100">
                        <Tabs card lazy @input="tabChanged">
                            
                            <!--- Grafico storico test fuzionali automatici -->   
                            <TabItem :name="this.$t('graph.title_functional')" class="pt-4 pl-4 pr-4">
                                <b-row>
                                <b-col cols="6">    
                                <b-form inline>
                                    <label for="grafico1-year" class="typo-label">{{this.$t('graph.period')}}:</label>
                                    <b-form-select v-if="grafico1Periodo.indexOf('-') < 0" id="grafico1-year" v-model="grafico1Periodo" :options="graphPeriods" :value="''" class="ml-2" ></b-form-select>
                                    <div v-else>
                                      <span  style="padding-left:10px">{{moment(grafico1Periodo, 'YYYY-MM').locale('it').format('MMMM YYYY')}}</span> <b-button @click="grafico1Periodo = ''">&laquo; Indietro</b-button>
                                    </div>
                                </b-form>
                                </b-col>
                                <b-col cols="6">    
                                <b-form inline class="float-right">
                                    <label for="grafico1-year" class="typo-label">{{this.$t("graph.select_central")}}</label>
                                    <b-form-select id="grafico1-year" v-model="grafico1Centrali" :options="graphCentrals" :value="''" class="ml-2" >
                                    </b-form-select>
                                </b-form>
                                </b-col>
                                </b-row>
                                <div style=" display: block"  class="mt-3">
                                    <grafico-storico v-if="logbookDetails!=null" :key="keyGraph" chartId="chart-bar-01" ref="grafico1" :graphType="'test_funzionale_automatico'" :anno="grafico1Periodo" :cu="grafico1Centrali" v-on:selectedMonth="selectedMonth" />
                                </div>
                            </TabItem>
                           
                            <!--- Grafico storico test autonomia automatici -->   
                            <TabItem :name="this.$t('graph.title_autonomy')" class="pt-4 pl-4 pr-4" >
                                <b-row>
                                <b-col cols="6">  
                                <b-form inline>
                                    <label for="grafico2-year" class="typo-label">{{this.$t('graph.period')}}:</label>
                                    <b-form-select v-if="grafico2Periodo.indexOf('-') < 0" id="grafico2-year" v-model="grafico2Periodo" :options="graphPeriods" :value="''" class="ml-2" ></b-form-select>
                                    <div v-else>
                                      <span  style="padding-left:10px">{{moment(grafico2Periodo, 'YYYY-MM').locale('it').format('MMMM YYYY')}}</span> <b-button @click="grafico2Periodo = ''">&laquo; Indietro</b-button>
                                    </div>
                                </b-form>
                                </b-col>
                                <b-col cols="6">    
                                <b-form inline class="float-right">
                                    <label for="grafico1-year" class="typo-label">{{this.$t("graph.select_central")}}</label>
                                    <b-form-select id="grafico1-year" v-model="grafico2Centrali" :options="graphCentrals" :value="''" class="ml-2" >
                                    </b-form-select>
                                </b-form>
                                </b-col>
                                </b-row>
                                <div style=" display: block"  class="mt-3">
                                    <grafico-storico :key="keyGraph"  chartId="chart-bar-02" ref="grafico2" :graphType="'test_autonomia_automatico'" :anno="grafico2Periodo" :cu="grafico2Centrali" v-on:selectedMonth="selectedMonth" />
                                </div>
                            </TabItem>

                            <!--- Grafico storico eventi di rete -->   
                           <!-- <TabItem :name="this.$t('graph.title_eventMain')" class="pt-4 pl-4 pr-4">
                                 <b-row>
                                <b-col cols="5"> 
                                <b-form inline>
                                    <label for="grafico3-year" class="typo-label">{{this.$t('graph.period')}}:</label>
                                    <b-form-select id="grafico3-year" v-model="grafico3Periodo" :options="graphPeriods" :value="''" class="ml-2">
                                    </b-form-select>
                                </b-form>
                                </b-col>
                                 <b-col cols="7"> 
                                   <label class="typo-label">{{this.$t('graph.delete_central')}}</label>
                                </b-col>
                                </b-row> 
                                <div style=" display: block" class="mt-3">
                                    <grafico-eventi-rete chartId="chart-bar-03" ref="grafico3" :anno="grafico3Periodo"/>
                                </div>
                            </TabItem>-->
                        </Tabs>


                    </b-card>
                    <b-card v-if="!isPro || $store.getters.isProExpired" :title="this.$t('settings.storicData')" class="home-widget bg-secondary text-widget radius-card h-100">
                        <p>{{this.$t("settings.graphPro")}} <b-link @click="passaAPro" >{{this.$t("settings.activePro")}}</b-link></p>
                        <img src="img/obscureStorico.png" class = "img-fluid">
                    </b-card>
                </b-col>
            </b-row>

            <p style="height: 50px">&nbsp;</p>
           
        </div>
    </div>
</template>

<script>

//import Vue from 'vue'
import NavBarMain from '@/components/NavBarMain'
import NavBarBasic from '@/components/NavBarBasic'
import GraficoErrori from '@/components/GraficoErrori'
import GraficoStorico from '@/components/GraficoStorico'
import GraficoEventiRete from '@/components/GraficoEventiRete'
import GraficoDonut from '@/components/GraficoDonut'
import GraficoDonutEnergy from '@/components/GraficoDonutEnergy'
import PlantMap from '@/components/PlantMap'
import AlertOverview from '@/components/AlertOverview'
import ReportOverview from '@/components/ReportOverview'
import ReportBleOverview from '@/components/ReportBleOverview'
import BannerPro from '@/components/BannerPro'
import BannerProExpired from '@/components/BannerProExpired'
import moment, { unix } from 'moment'
import { mapState } from 'vuex'

export default {
    name: 'HomeImpianto',    
    components: {
        NavBarMain,
        NavBarBasic,
        PlantMap,
        ReportOverview,
        ReportBleOverview,
        AlertOverview,
        BannerPro,
        BannerProExpired,
        GraficoErrori,
        GraficoStorico,
        GraficoEventiRete,
        GraficoDonut,
        GraficoDonutEnergy,
        Event
    },
    props: ['pid'],
    data() {
        return {
            grafico1Periodo: '',
            grafico2Periodo: '',
            grafico3Periodo: '',
            grafico1Centrali: this.$t("graph.all_central"),
            grafico2Centrali: this.$t("graph.all_central"),
            grafico3Centrali: this.$t("graph.all_central"),
            keyGraph:0,
            tabLoaded:false,

            plantId: null,
            titleMap:"pippo",

            //heading e valori della tabella report
            reportFields: [
                {key: 'dataEv', label:'Data test'},
                {key: 'cod', label:'Centrale'},
                {key: 'type', label:'Tipo'},
                {key:'evDesc', label:'Tipo di test'},
                {key:'evEsito', label:'Esito'}],
            reportItems: [           
            ],
            reportTestFields: [
                {key: 'dataEv', label:'Data report'},
                {key: 'cod', label:'Centrale / Tipologia'},
                {key: 'evEsito', label:'Esito', tdClass: 'text-center align-middle'},
                {key:'evDesc', label:'Report', tdClass: 'align-middle'}],
            reportTestItems: [           
            ],

         

            //definizione della posizione sulla mappa
            center: {lat: 44.486170, lng: 11.102187},
            markers: [{
                position: {lat: 44.486170, lng: 11.102187}
            }],   
            checkedInvitoPendente: false,
            invitoPendente: null,
            plant_energia_consumata: 0,
            plant_energia_risparmiata: 0,
            plant_energia_sostituita: 0,
            plant_power:0,
            plant_timeon:0,
            energy_saved:480000000,
            energy_consumed:620000000,
            // plant_energy: 0,
        }
    },
    beforeRouteUpdate(to,from,next) {
        //this.name = to.params.name
        console.log("before route update", to, this.plantId, this.pid)
        this.plantId = to.params.pid
        if (this.$store.state.user != null) {

            this.$store.state.plantUnits = null;
            this.$store.state.plantZones = null;
            this.$store.state.bleLogbooks = null;
            this.$store.state.currentLogbooks = null;

            this.$store.dispatch('loadPlantDetails', this.plantId);
            /*console.log("2 homeImpianto, dispatch loadLogbookDetails");
            this.$store.dispatch('loadLogbookDetails', this.plantId)
            this.$store.dispatch('loadBleLogbooks', this.plantId)*/
        }
        next()
    },
    computed: {
        ...mapState(['loading','error']),
        graphPeriods() {
            var periods = [];
            var date = this.moment(new Date()).startOf('year');
            for (var i=0; i< 20; i++) {
                periods.push(date.format('YYYY'));
                date.subtract(1,'year');
            }
            periods.unshift({text:this.$t("graph.last_year"), value:''});
            return periods;
        },
        graphCentrals() {
            var centrals = [];
            if (this.unitsDetails)
            {
                for (var i=0; i< this.unitsDetails.length; i++) 
                {
                    centrals.push(this.unitsDetails[i].cu_id);
                }
                centrals.unshift(this.$t("graph.all_central"));
            }
            console.log("Graph centrali",centrals);
            return centrals;
        },
        isPro() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return false;
            return (plant.plant_type == 'pro' || plant.plant_type == 'premium');
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        zonesDetails() {
            return this.$store.state.plantZones;
        },
        bleLogbooks() {
            return this.$store.state.bleLogbooks;
        },
        numUnitsOk() {
            var CuOk=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
                if(this.unitsDetails[k].cu_connected==true)
                    {
                        if(this.unitsDetails[k].cu_type=="sicuro")
                        {
                            //if(this.unitsDetails[k].cu_error.error_battery_symmetry=="OFF")
                            if (this.unitsDetails[k].cu_error.error_general === "OFF" && this.unitsDetails[k].cu_connected==true)
                            {
                                CuOk.push(this.unitsDetails[k].cu_id);
                            }
                        }
                        else
                        {
                            CuOk.push(this.unitsDetails[k].cu_id);
                        }
                    }
            }
            console.log("CU funzionanti",CuOk);

            //Calcolo energie
            this.calcolaEnergie();

            return CuOk.length;
        },

        //----------------------------
        // Control units disconnected
        //----------------------------
        numUnitsDisconnected() {
            var CuDisconnected=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
               {
                if(this.unitsDetails[k].cu_connected==false)
                  CuDisconnected.push(this.unitsDetails[k].cu_id);
               }
               console.log("CU non raggiungibili",CuDisconnected);
               return CuDisconnected.length;
        },
        //---------------------
        // Control units fail
        //---------------------
        numUnitsFail() {
            var CuFail=[];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;

            //num units fail solo per sistemi centralizzati Sicuro
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_error)
               {
                if(this.unitsDetails[k].cu_type=="sicuro")
                {
                    if(//this.unitsDetails[k].cu_error.error_battery_symmetry=="ON"
                       //|| this.unitsDetails[k].cu_error.error_autonomy_test=="ON"
                       //|| this.unitsDetails[k].cu_error.error_functional_test=="ON"
                       this.unitsDetails[k].cu_error.error_general === "ON"
                       && this.unitsDetails[k].cu_connected==true)
                       CuFail.push(this.unitsDetails[k].cu_id);
                }
               }
            }
            console.log("CU sicuro in errore",CuFail);
            return CuFail.length;

        },
        //restituisce il numero di dispositivi (illuminazione ed emergenza) che appartengono a centrali non connesse
        //prioritario su tutti gli altri parametri (numLampsOrphan, numLampsFail, numLampsOk)
        numLampsDisconnected() {
            var numLampsDisconnected=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if (this.unitsDetails[k].cu_connected==false && this.unitsDetails[k].cu_type!="sicuro")
                numLampsDisconnected=numLampsDisconnected+this.unitsDetails[k].lamps.length+this.unitsDetails[k].lamps_illum.length+this.unitsDetails[k].sensors.length;
               if (this.unitsDetails[k].cu_connected==false && this.unitsDetails[k].cu_type=="sicuro")
                numLampsDisconnected=numLampsDisconnected+this.unitsDetails[k].num_lamp_found;

            }
            console.log("CU Lamps non raggiungibili: " ,numLampsDisconnected);
            return numLampsDisconnected;
        },
        //restituisce il numero di dispositivi (illuminazione ed emergenza) orfani di Centrali connesse
        numLampsOrphan() {
            var numOrphans=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (const elem of this.unitsDetails)
            {
                if (elem.cu_connected == true) {
                    if (elem.num_nodi_orfani != null) 
                        numOrphans += elem.num_nodi_orfani;
                }
            }
            return numOrphans;
        },
        //restituisce il numero di dispositivi (illuminazione ed emergenza) bluetooth non gestiti da gateway ma presenti in impianto centralizzato
        numLampsBleNoGateway() {

            var numBleLampsNoGateways = {
                    all: 0,
                    emergency: 0,
                    ordinary: 0,
                    emergencyPass: 0,
                    emergencyFail: 0,
                    ordinaryPass: 0,
                    ordinaryFail: 0 
            };
                
            var numLampsInGateways = 0;
            var numEmergencyPassGateways = 0;
            var numEmergencyFailGateways = 0;
            var numOrdinaryPassGateways = 0;
            var numOrdinaryFailGateways = 0;

            var numLampsInZones = 0;
            var numEmergencyPassZones = 0;
            var numEmergencyFailZones = 0;
            var numOrdinaryPassZones = 0;
            var numOrdinaryFailZones = 0;
            

            if (this.unitsDetails == null || this.unitsDetails.length == 0) return numBleLampsNoGateways;
            if (this.zonesDetails == null || this.zonesDetails.length == 0) return numBleLampsNoGateways;

            // num lamps ble in gateway
            for (const elem of this.unitsDetails)
            {
                if (elem.cu_type == "blegateway")
                {
                    if (elem.num_lamp_present != null)
                    {
                        numLampsInGateways += elem.num_lamp_present;
                    }

                    //ordinary lamps in gateways
                    if (elem.lamps_illum != null && elem.lamps_illum.length > 0)
                    {
                        for (const l of elem.lamps_illum) {
                            if (l.lampFail == "OFF" &&
                                l.errorBallastCom == "OFF" &&
                                l.error_batt_short == "OFF" &&
                                l.error_batt_test == "OFF" &&
                                l.error_batt_test_auto == "OFF" &&
                                l.error_com == "OFF" &&
                                l.error_hardware == "OFF" &&
                                l.error_led == "OFF"
                            )
                                numOrdinaryPassGateways++;
                            else
                                numOrdinaryFailGateways++;
                        }
                    }

                    //emergency lamps in gateway
                    if (elem.lamps != null && elem.lamps.length > 0)
                    {
                        for (const l of elem.lamps) {
                            if (l.lampFail == "OFF" &&
                                l.errorBallastCom == "OFF" &&
                                l.error_batt_short == "OFF" &&
                                l.error_batt_test == "OFF" &&
                                l.error_batt_test_auto == "OFF" &&
                                l.error_com == "OFF" &&
                                l.error_hardware == "OFF" &&
                                l.error_led == "OFF"
                            )
                                numEmergencyPassGateways++;
                            else
                                numEmergencyFailGateways++;
                        }
                    }
                }
                    
            }
                    
            // num lamps ble in zones
            for (const zone of this.zonesDetails)
            {
                if (zone.bleLamps && zone.bleLamps.length > 0)
                    numLampsInZones += zone.bleLamps.length;

                    for (const l of zone.bleLamps)
                        {
                            if (l.model == 9)
                            {
                                if (l.lampFail == "OFF" &&
                                    l.errorBallastCom == "OFF" &&
                                    l.error_batt_short == "OFF" &&
                                    l.error_batt_test == "OFF" &&
                                    l.error_batt_test_auto == "OFF" &&
                                    l.error_com == "OFF" &&
                                    l.error_hardware == "OFF" &&
                                    l.error_led == "OFF"
                                )
                                    numOrdinaryPassZones++;
                                else
                                    numOrdinaryFailZones++;    
                            }
                            else
                            {
                                 if (l.lampFail == "OFF" &&
                                    l.errorBallastCom == "OFF" &&
                                    l.error_batt_short == "OFF" &&
                                    l.error_batt_test == "OFF" &&
                                    l.error_batt_test_auto == "OFF" &&
                                    l.error_com == "OFF" &&
                                    l.error_hardware == "OFF" &&
                                    l.error_led == "OFF"
                                )
                                    numEmergencyPassZones++;
                                else
                                    numEmergencyFailZones++;    
                            }
                        }
            }

            numBleLampsNoGateways.all = numLampsInZones - numLampsInGateways;
            numBleLampsNoGateways.emergencyPass = numEmergencyPassZones - numEmergencyPassGateways;
            numBleLampsNoGateways.emergencyFail = numEmergencyFailZones - numEmergencyFailGateways;
            numBleLampsNoGateways.emergency = numBleLampsNoGateways.emergencyPass + numBleLampsNoGateways.emergencyFail;

            numBleLampsNoGateways.ordinaryPass = numOrdinaryPassZones - numOrdinaryPassGateways;
            numBleLampsNoGateways.ordinaryFail = numOrdinaryFailZones - numOrdinaryFailGateways;
            numBleLampsNoGateways.ordinary = numBleLampsNoGateways.ordinaryPass + numBleLampsNoGateways.ordinaryFail;

            console.log("bluetooth lamps no Gateway: ", numBleLampsNoGateways);

            return numBleLampsNoGateways;
        },
        //restituisce il numero di lampade d'illuminazione che appartengono a Centrali disconnesse
        numIllumDisconnected() {
            var numIllumDisconnected=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==false && this.unitsDetails[k].lamps_illum!=null)
               numIllumDisconnected=numIllumDisconnected+this.unitsDetails[k].lamps_illum.length;
            }
            console.log("CU LAMP ILLUM non raggiungibili: " ,numIllumDisconnected);
            return numIllumDisconnected;
        },
        //restituisce il numero di sensori che appartengono a Centrali disconnesse
        numSensorDisconnected() {
            var numSensorDisconnected=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==false)
               numSensorDisconnected=numSensorDisconnected+this.unitsDetails[k].sensors.length;
            }
            console.log("CU SENSOSR non raggiungibili: " ,numSensorDisconnected);
            return numSensorDisconnected;
        },
        //restituisce il numero di dispositivi con errore che appartengono a Centrali connesse
        numLampsFail() {
            var numLampFail=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if(this.unitsDetails[k].cu_connected==true)
               {
                if (this.unitsDetails[k].num_lamp_error != null)
                    numLampFail=numLampFail + this.unitsDetails[k].num_lamp_error;
            //     if(this.unitsDetails[k].num_nodi_orfani)
            //         numLampFail=numLampFail + this.unitsDetails[k].num_nodi_orfani;
               }
            }
            console.log("CU LAMP in errore: " ,numLampFail);
            return numLampFail;
        },
        //restituisce il numero di dispositivi senza errore che appartengono a Centrali connesse
        numLampsOk() {
            var numLampOk=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
               if (this.unitsDetails[k].cu_connected==true)
                numLampOk=this.totalLamps-this.numLampsFail-this.numLampsDisconnected-this.numLampsOrphan-this.numLampsBleNoGateway.all;
            }
            console.log("CU LAMP funzionanati: " ,numLampOk);
            return numLampOk;
        },
        numLampsBleOk() {
            var numLampOk=0;
            if (this.zonesDetails == null || this.zonesDetails.length == 0) return 0;
            for (let k=0;k<this.zonesDetails.length;k++)
            {
               if(this.zonesDetails[k].bleLamps.length>0)
                    for (let j=0;j<this.zonesDetails[k].bleLamps.length;j++)
                    { 
                        if(this.zonesDetails[k].bleLamps[j].lamp.errorBallastCom=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.lampFail=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_com=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_short=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_test=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_test_auto=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_hardware=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_led=="OFF"                                
                        )              
                            numLampOk=numLampOk+1;
                    }
            }
            console.log("Lamps Ble OK: " ,numLampOk);
            return numLampOk;
        },
        numUnits() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            return this.unitsDetails.length;
        },
        totalLamps() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            var total_centralized = this.unitsDetails.reduce(function(total,u){
                if(u.cu_type=="cablecom" || u.cu_type=="sicuro")
                    return total + (u.num_lamp_found | 0);
                else
                    return total + (u.num_lamp_present | 0);
            }, 0);     
            console.log("total lamps centralized: " + total_centralized);
            console.log("total lamps no gateway: " + this.numLampsBleNoGateway.all);
            return total_centralized + this.numLampsBleNoGateway.all    
        },
        totalLampsGateway() {
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            return this.unitsDetails.reduce(function(total,u){
                if(u.cu_type=="blegateway")
                    return total + (u.num_lamp_present | 0);
            },0);          
        },
        totalLampsBle() {
            if (this.zonesDetails == null || this.zonesDetails.length == 0) return 0
            return this.zonesDetails.reduce(function(total,z){
                    return total + (z.bleLamps.length | 0);
            },0);          
        },
        totalEmergency() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
               if(u.lamps && u.cu_type!="sicuro")
                {
                    total= total + u.lamps.length;
                }
                else 
                {
                    total= total + u.num_lamp_found;
                }

            });
            total = total + this.numLampsBleNoGateway.emergency;
            console.log("total emergency", total);  
            return total        
        },

        //Restituisce il numero di lampade di emergenza orfane di Centrali connesse
        numEmergencyOrphan() {
            var numOrphans=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            this.unitsDetails.forEach((u) => {
                if (u.cu_connected == true) {
                    u.lamps.forEach((l) => {
                        if ((l.nodo_orfano)) numOrphans++;
                    });
                }
            });
            return numOrphans;
        },
        //Restituisce il numero di lampade di Emergenza con errore (escluse le orfane)
        numEmergencyFail() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) => {
                if((u.num_lamp_found != null) && (u.cu_connected==true))
                {
                    
                   if(u.cu_type=="sicuro") //ci sono solo lampade d'emergenza
                   {
                        total += u.num_lamp_error;   
                   }
                   else
                   { 
                        u.lamps.forEach((l) =>{
                        if(l.error_batt_short=="ON" || l.error_batt_test=="ON"
                            || l.error_batt_test_auto=="ON" || l.error_tubo_UV=="ON"
                            || l.error_com=="ON"
                            || l.error_led=="ON"
                            || l.error_comm_radio_lamp=="ON"
                            // || l.error_hardware=="ON" || l.nodo_orfano==true)
                            || l.error_hardware=="ON")
                            total=total+1;
                    });
                    }
                }
            });
            console.log("num emergency fail",total)  
            return total        
        },
        //restituisce il numero di lampade d'emergenza che non hanno errori
        numEmergencyPass() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
                if ((u.num_lamp_found != null) && (u.cu_connected==true))
                {
                    if(u.cu_type=="sicuro")
                    {
                        total = total + (u.num_lamp_found - u.num_lamp_error);   
                    }
                    else
                    { 
                        u.lamps.forEach((l) => {
                            if(l.error_batt_short!="ON" && l.error_batt_test!="ON"
                                && l.error_batt_test_auto!="ON" && l.error_tubo_UV!="ON"
                                && l.error_com!="ON"
                                && l.error_comm_radio_lamp!="ON"
                                && l.error_led!="ON"
                                && l.error_hardware!="ON" && (!l.nodo_orfano || l.nodo_orfano==false))
                                total=total+1;
                        });
                    }
                }
            });
            console.log("num emergency pass",total)  
            return total        
        },
        //Restituisce il numero di lampade di Emergenza che appartengono a Centrali ora non connesse
        numEmergencyDisconnected() {
            var numEmergencyDisconnected=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k=0;k<this.unitsDetails.length;k++)
            {
                if(this.unitsDetails[k].cu_connected==false)
                    if (this.unitsDetails[k].cu_type === 'sicuro')
                        numEmergencyDisconnected = numEmergencyDisconnected + this.unitsDetails[k].num_lamp_found;
                    else 
                        numEmergencyDisconnected = numEmergencyDisconnected + this.unitsDetails[k].lamps.length;
            }
            console.log("CU EMERGENCY non raggiungibili: " ,numEmergencyDisconnected);
            return numEmergencyDisconnected;
        },

        numIllumPass() {
            if (this.unitsDetails == null) return 0
            var total = 0;
            this.unitsDetails.forEach((u) =>{

                if (u.lamps_illum && u.cu_connected == true)
                {
                   u.lamps_illum.forEach((l) =>{
                        if(l.error_batt_short!="ON" && l.error_batt_test!="ON"
                            && l.error_batt_test_auto!="ON" && l.error_tubo_UV!="ON"
                            && l.error_com!="ON"
                            && l.error_comm_radio_lamp!="ON"
                            && l.error_led!="ON"
                            && l.error_hardware!="ON"
                            && l.error_overpower!="ON"
                            && l.error_underpower!="ON"
                            && l.error_overvoltage!="ON"
                            && l.error_undervoltage!="ON"
                            && (!l.nodo_orfano || l.nodo_orfano==false))
                            total=total+1;
                    });
                }

            });
            console.log("num illum pass",total)  
            return total        
        },
        numSensorPass() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
                if(u.lamps_altro_id && u.cu_connected==true)
                {
                   u.sensors.forEach((l) =>{
                        if(l.error_batt_short!="ON" && l.error_batt_test!="ON"
                            && l.error_batt_test_auto!="ON" && l.error_tubo_UV!="ON"
                            && l.error_com!="ON"
                            && l.error_comm_radio_lamp!="ON"
                            && l.error_led!="ON"
                            && l.error_hardware!="ON"
                            && l.error_overpower!="ON"
                            && l.error_underpower!="ON"
                            && l.error_overvoltage!="ON"
                            && l.error_undervoltage!="ON"
                            && (!l.nodo_orfano || l.nodo_orfano==false))
                            total=total+1;
                    });
                }

            });
            console.log("num sensors pass",total)  
            return total        
        },
        numIllumFail() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) => {

                if (u.lamps_illum && u.cu_connected == true)
                {
                   u.lamps_illum.forEach((l) =>{
                        if(l.error_batt_short=="ON" || l.error_batt_test=="ON"
                            || l.error_batt_test_auto=="ON" || l.error_tubo_UV=="ON"
                            || l.error_com=="ON" || l.error_led=="ON"
                            || l.error_comm_radio_lamp=="ON"
                            || l.error_hardware=="ON"
                            || l.error_overpower=="ON"
                            || l.error_underpower=="ON"
                            || l.error_overvoltage=="ON"
                            || l.error_undervoltage=="ON")
                            // || l.nodo_orfano==true)
                            total=total+1;
                    });
                }

            });
            console.log("num illum fail",total)  
            return total        
        },
        //Restituisce il numero di lampade di illuminazione orfane di Centrali connesse
        numIllumOrphan() {
            var numOrphans=0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            this.unitsDetails.forEach((u) => {
                if((u.lamps_illum!=null) && (u.cu_connected == true))
                {
                    u.lamps_illum.forEach((l) => {
                        if (l.nodo_orfano) numOrphans++;
                    });
                }
            });
            return numOrphans;
        },
        //Restituisce il numero di sensori in errore
        numSensorFail() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
                if(u.lamps_altro_id && u.cu_connected==true)
                {
                   u.sensors.forEach((l) =>{
                        if(l.error_batt_short=="ON" || l.error_batt_test=="ON"
                            || l.error_batt_test_auto=="ON" || l.error_tubo_UV=="ON"
                            || l.error_com=="ON" || l.error_led=="ON"
                            || l.error_comm_radio_lamp=="ON"
                            || l.error_hardware=="ON"
                            || l.error_overpower=="ON"
                            || l.error_underpower=="ON"
                            || l.error_overvoltage=="ON"
                            || l.error_undervoltage=="ON")
                            // || l.nodo_orfano==true)
                            total=total+1;
                    });
                }

            });
            console.log("num sensors fail",total)  
            return total        
        },
        //Restituisce il numero di sensori orfani di Centrali connesse
        numSensorOrphan() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
                if(u.lamps_altro_id && u.cu_connected==true)
                {
                   u.sensors.forEach((l) =>{
                        if (l.nodo_orfano == true)
                            total++;
                    });
                }
            });
            console.log("num sensors pass",total)  
            return total        
        },

        totalIllum() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) => {

               if(u.lamps_illum)
                {
                    total= total + u.lamps_illum.length;
                }
            });
            total=total + this.numLampsBleNoGateway.ordinary;
            return total        
        },
        totalSensor() {
            if (this.unitsDetails == null) return 0
            var total=0;
            this.unitsDetails.forEach((u) =>{
                if(u.lamps_altro_id)
                {
                    total= total + u.lamps_altro_id.length;
                }
            });
            console.log("total sensori",total)  
            return total        
        },
        errorGraphCent() {
            if (this.$store.state.plantUnits == null) return null;
            var num_gateway = 0;
            var num_cent = 0;
            var deviceTypes = "";
            this.unitsDetails.forEach((u) => {
                if(u.cu_type=="blegateway")
                {
                    num_gateway++;
                }
                else
                {
                    num_cent++;
                }
            });
            if (num_gateway > 0 && num_cent > 0)
                deviceTypes = "cu_gateways"
            else if (num_gateway > 0 && num_cent == 0)
                deviceTypes = "gateways"
            else
                deviceTypes ="cu"
            return [deviceTypes,this.numUnits,this.numUnitsOk,this.numUnitsFail,this.numUnitsDisconnected,0,0];
        },
        errorGraphLamp() {
            if (this.$store.state.plantUnits == null) return null;
            return ["device",this.totalLamps,this.numLampsOk,this.numLampsFail,this.numLampsDisconnected,this.numLampsBleNoGateway.all,this.numLampsOrphan];
        },
        errorGraphLampBle() {
            if (this.$store.state.plantZones == null) return null;
            console.log("total lamps Ble" , this.totalLampsBle);
            return ["bluetooth",this.totalLampsBle,this.numLampsBleOk,(this.totalLampsBle- this.numLampsBleOk),0,0,0];
        },
        errorGraphEmergency() {
            if (this.$store.state.plantUnits == null) return null;
            return ["emergency",this.totalEmergency,this.numEmergencyPass,this.numEmergencyFail,this.numEmergencyDisconnected,this.numLampsBleNoGateway.emergency, this.numEmergencyOrphan];
        }, 
        errorGraphIllum() {
            if (this.$store.state.plantUnits == null) return null;
            return ["lighting",this.totalIllum,this.numIllumPass,this.numIllumFail,this.numIllumDisconnected,this.numLampsBleNoGateway.ordinary,this.numIllumOrphan];
        }, 
        errorGraphSensori() {
            if (this.$store.state.plantUnits == null) return null;
            return ["sensor",this.totalSensor,this.numSensorPass,this.numSensorFail,this.numSensorDisconnected, 0, this.numSensorOrphan ];
        },
        energyGraph(){
            if (this.$store.state.plantUnits == null) return null;
            console.log("energia risp:", this.plant_energia_risparmiata)
            console.log("energia cons:", this.plant_energia_consumata)
            if (this.plant_energia_consumata == 0) return ["energy",this.plant_energia_risparmiata.toFixed(0),1];
            return ["energy",this.plant_energia_risparmiata.toFixed(0),this.plant_energia_consumata.toFixed(0)];
        },
        logbookDetails() {
            const logbook = this.$store.state.currentLogbooks;
            console.log("logbook trovata",logbook);
            return logbook;
        },

    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            console.log("homeImpianto from " + from.path);
            if (from.path.includes("nto")) {
                console.log("homeImpianto from " + from.path);
                vm.$store.dispatch('loadPlantDetails', vm.plantId);
            } 
            next()
        });
    },
    mounted() {
        console.log("homeImpianto mounted, idImpianto=" + this.plantId,this.pid, this.$route)
        this.plantId = this.$route.params.pid
        if (this.$store.state.user != null)
        {
            console.log("WATCH MOUNTED: Utente diverso da null: " + this.$store.state.user);

            if(this.plantDetails == null)
                this.$store.dispatch('loadPlantDetails', this.plantId);

            if (!this.checkedInvitoPendente) {
                this.checkedInvitoPendente = true;
                console.log("verifico se ha invito pendente");
                this.$store.dispatch('getInvitoPendente');
            }
        }
    },
    updated() {

    },
    watch: {
        loading(val) {
            console.log("homeImpianto loading changed:" + val+", error=" + this.error+", bleLogbooks" + this.bleLogbooks + ", zone"+ this.zonesDetails);
            if (val == false && this.plantDetails == null && this.$store.state.socket != null && this.error == null)
            {
                console.log("WATCH: carico plant details");
                this.$store.dispatch('loadPlantDetails', this.plantId)
            }
            else if (val == false && this.plantDetails != null &&  this.zonesDetails == null && this.$store.getters.isBluetooth && this.error == null) {
                console.log("WATCH: carico zone bluetooth");
                 this.$store.dispatch('loadPlantZones', this.plantId);      
            } 
            else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.$store.getters.isCentralized && this.error == null)
            {
                console.log("WATCH: carico units details");
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            }
            else if (val == false && this.plantDetails != null && this.zonesDetails != null && this.bleLogbooks == null && this.$store.getters.isBluetooth && this.error == null)
            {
                console.log("WATCH: carico logbook bluetooth: ", this.bleLogbooks);
                this.$store.dispatch('loadBleLogbooks', this.plantId)
            }
            else if (val == false && this.plantDetails != null && this.unitsDetails != null && this.$store.state.currentLogbooks == null && this.$store.getters.isCentralized && this.error == null)
            {
                console.log("WATCH: carico logbook details");
                this.$store.dispatch('loadLogbookDetails', this.plantId)
            }
            else if (val == false) {

                const cmdResp = this.$store.state.commandResponse;
                

                console.log("homeImpianto cmdResp =",cmdResp, this.$store.state.invite, this.$store.getters.user);
                if (cmdResp != null && !cmdResp.pending && cmdResp.command == 'checkInvitoPendente' && cmdResp.response.data.error!="INVITE_NOT_FOUND") {
                    console.log("ricevuta risposta checkInvitoPendente -->", cmdResp.response);
                    this.invitoPendente = cmdResp.response.data.invite
                    return;
                }


                if (this.$store.state.invite != null && this.$store.getters.user != null) {
                    console.log("homeimpianto, devo gestire invito utente di tipo " + this.$store.state.inviteType+", usertype=" + this.$store.getters.userType);
                    if (this.$store.state.inviteType == 'client') {
                        
                        if(this.$store.getters.userType=='basic' && this.$store.state.clientRegistrationData!=null)
                        {                         
                          console.log("homeImpianto, è un utente che ha compilato il form di registrazione come cliente",this.$store.state.clientRegistrationData)
                          var clientData=this.$store.state.clientRegistrationData;
                     
                          this.userName=clientData.name;
                          this.userSurname=clientData.surname;
                          this.userPhone=clientData.phone;
                          this.userStreet=clientData.street;
                          this.userNumber=clientData.housenumber;
                          this.userCity=clientData.city;
                          this.userCap=clientData.cap;
                          this.userProv=clientData.prov;
                          this.userCountry=clientData.country;
                          if(clientData.businessName)
                          {
                            this.picked="company";
                            this.userbusinessName=clientData.businessName;
                            this.userPiva=clientData.piva;
                          }
                          else
                          {
                            this.picked="person";
                          }
                          this.userType="client";
                          //this.saveProfile();
                          this.$store.dispatch("dbSaveProfile",{"name":this.userName, "surname":this.userSurname, "businessname":this.userbusinessName, "piva":this.userPiva,"phone":this.userPhone, "street":this.userStreet, "housenumber":this.userNumber,"city":this.userCity,"cap":this.userCap,"prov":this.userProv,"country":this.userCountry,"userType":this.userType});
                          //this.$router.go();
                          return;
                        }

                        if (this.$store.getters.userType == 'basic') {
                            console.log("utente corrente deve fare registrazione a client")
                            let self = this;
                            this.$bvModal.msgBoxOk('Per attivare l\'invito a diventare proprietario dell\'impianto è necessario completare il form di registrazione', {
                                title: 'Attenzione!',
                                okVariant: 'primary',
                                okTitle: "Ok, Procedi",
                                centered: true
                            }).then(() => {
                                self.$bvModal.show("modal-client");
                            });

                            return;
                        }
                    }
                    console.log("Invia accetta invito");
                    this.$store.dispatch('acceptInvite');
                    return;
                }


            }
        }
    },

    methods: {
        //Calcola i valori di energia consumata e risparmiata dalle lampade di illuminazione
        calcolaEnergie() {
            if (this.unitsDetails == null) return 0
            // this.plant_energy=0;
            this.plant_timeon=0;
            this.plant_power=0;
            this.plant_power_substituted=0;
            this.plant_energia_consumata=0;
            this.plant_energia_risparmiata=0;
            this.plant_energia_sostituita=0;
            this.unitsDetails.forEach((u) =>{
                if(u.energie_totali)
                {
                    if(u.energie_totali.energia_sostituita)
                        this.plant_energia_sostituita=this.plant_energia_sostituita + parseFloat((u.energie_totali.energia_sostituita/1000).toFixed(1));
                    if(u.energie_totali.energia_consumata)
                        this.plant_energia_consumata=this.plant_energia_consumata + parseFloat((u.energie_totali.energia_consumata/1000).toFixed(1));
                    if(u.energie_totali.energia_risparmiata)               
                        this.plant_energia_risparmiata=this.plant_energia_risparmiata + parseFloat((u.energie_totali.energia_risparmiata/1000).toFixed(1));         
                }
                if(u.lamps_illum_id)
                {
                    u.lamps_illum.forEach((l) =>{
                        // if(l.Energy)
                        //     this.plant_energy=this.plant_energy + parseFloat((l.Energy/1000).toFixed(1));
                        if(l.TimeOn)
                            this.plant_timeon=this.plant_timeon + parseFloat((l.TimeOn/1).toFixed(0));
                        if(l.potenza_attuale)
                            this.plant_power=this.plant_power + parseFloat((l.potenza_attuale/1).toFixed(1));
                        if(l.potenza_sostituita)
                            this.plant_power_substituted=this.plant_power_substituted + parseFloat((l.potenza_sostituita/1).toFixed(1));
                    });
                }
            });
            // console.log("plant energy",this.plant_energy.toFixed(1));
            console.log("plant energia sostituita",this.plant_energia_sostituita.toFixed(1));
            console.log("plant energia consumata",this.plant_energia_consumata.toFixed(1));
            console.log("plant energia risparmiata",this.plant_energia_risparmiata.toFixed(1));
            console.log("plant timeon",this.plant_timeon);  
            console.log("plant power",this.plant_power.toFixed(1));
            console.log("plant power subst",this.plant_power_substituted.toFixed(1));  
        },

        alertLogbook() {
            //filtra i logbook relativi esclusivamente a test funzionali e di autonomia che hanno presentato un errore
            var searchInLogbook=this.$store.state.currentLogbooks.filter(function(item)
            {
                return (item.log_type!="assenza_rete" && item.log_type!="rientro_rete")
            });
            //ordina i logbook per data partendo dalla data più recente
            searchInLogbook.sort(function (a, b) {
              return b.log_timestamp - a.log_timestamp;
            });  
            //considera solo gli ultimi logbook per ogni centrale
            var lastFuncTest;
            var lastAutoTest;
            var lastCentLogbook=[];
            for(var k=0;k<this.numUnits;k++)
            {
                lastFuncTest=searchInLogbook.find(element => (element.log_type=="test_funzionale_automatico" && element.cu_id==this.unitsDetails[k].cu_id));
                lastAutoTest=searchInLogbook.find(element => (element.log_type=="test_autonomia_automatico" && element.cu_id==this.unitsDetails[k].cu_id));
                if(lastFuncTest) lastCentLogbook.push(lastFuncTest);
                if(lastAutoTest) lastCentLogbook.push(lastAutoTest);
            }
            
            console.log("Ultimi Logbooh per centrale", lastCentLogbook);
 
            //inserisce i dati negli items della tabella con ultimi test
            let formatted_date="";
            let formatted_logtype="";
            this.alertItems=[];
            for (var i=0;i<lastCentLogbook.length;i++)
            {
                //Se ci sono errori negli ultimi logbook
                if(lastCentLogbook[i].log_esito!="pass")
                {
                    //Crea data correttamente formattata
                    var dateObj = new Date(lastCentLogbook[i].log_timestamp * 1000); 
                    formatted_date= dateObj.toLocaleDateString() + "\n" + dateObj.toLocaleTimeString('it-IT', { timeZone: 'UTC' });
                    formatted_logtype = this.$t("report_table."+ lastCentLogbook[i].log_type); 

                    //Trova lampada in errore e tipo di errore
                    var errorFound="";
                    var errorIcon="";
                    for (var n=0;n<lastCentLogbook[i].log_lamps.length;n++)
                    {
                        if(lastCentLogbook[i].log_lamps[n].error_batt_short=="ON") 
                            {
                                errorIcon="fa-battery-full";
                                errorFound=this.$t("details_lamp.lamp_error_batt_short");
                                this.alertItems.push({Data: formatted_date, Dev:lastCentLogbook[i].log_lamps[n].id, Cent:lastCentLogbook[i].cu_id, Type:lastCentLogbook[i].log_system, Desc:errorFound, Icon:errorIcon});
                            }
                        
                        if(lastCentLogbook[i].log_lamps[n].error_batt_test=="ON") 
                            {
                            errorIcon="fa-battery-full";
                            errorFound=this.$t("details_lamp.lamp_error_batt_test");
                                this.alertItems.push({Data: formatted_date, Dev:lastCentLogbook[i].log_lamps[n].id, Cent:lastCentLogbook[i].cu_id, Type:lastCentLogbook[i].log_system, Desc:errorFound, Icon:errorIcon});                       }
                        
                        if(lastCentLogbook[i].log_lamps[n].error_com=="ON") 
                            {
                                errorIcon="fa-exclamation-triangle";
                                errorFound=this.$t("details_lamp.lamp_error_com");
                                this.alertItems.push({Data: formatted_date, Dev:lastCentLogbook[i].log_lamps[n].id, Cent:lastCentLogbook[i].cu_id, Type:lastCentLogbook[i].log_system, Desc:errorFound, Icon:errorIcon});                       }
                            
                        if(lastCentLogbook[i].log_lamps[n].error_hardware=="ON") 
                            {
                                errorIcon="fa-microchip";
                                errorFound=this.$t("details_lamp.lamp_error_hardware");
                                this.alertItems.push({Data: formatted_date, Dev:lastCentLogbook[i].log_lamps[n].id, Cent:lastCentLogbook[i].cu_id, Type:lastCentLogbook[i].log_system, Desc:errorFound, Icon:errorIcon});
                            }

                        if(lastCentLogbook[i].log_lamps[n].error_led=="ON") 
                            {
                                errorIcon="fa-exclamation-triangle";
                                errorFound=this.$t("details_lamp.lamp_error_led");
                                this.alertItems.push({Data: formatted_date, Dev:lastCentLogbook[i].log_lamps[n].id, Cent:lastCentLogbook[i].cu_id, Type:lastCentLogbook[i].log_system, Desc:errorFound, Icon:errorIcon});                   }
                        
                    }
                }
            }   

            console.log ("alert in Logbook: " ,this.alertItems);  
        },

        getLastSync(){
            var lastSyncDate=moment('2023-01-01').toDate();
                for (var k=0;k<this.plantDetails.ble_lamps.length;k++ )
                   {
                        var lamp = this.plantDetails.ble_lamps[k];
                        var tempDate = moment(lamp.last_sync).toDate();
                        //console.log("Last sync lamp: " + k + " : ", tempDate);
                        if (tempDate>lastSyncDate)
                            lastSyncDate = tempDate;
                   }       
            console.log("Last sync plant", lastSyncDate);
            return moment(lastSyncDate).format('DD-MM-YYYY')
        },
        renderGraph(){
                this.keyGraph++;    
        },
        selectedMonth(value) {
            console.log("selected month",value);
            if (value.source == 'chart-bar-01') {
                this.grafico1Periodo = value.month
            } else if (value.source == 'chart-bar-02') {
                this.grafico2Periodo = value.month
            } 
        },
        tabChanged(){
            console.log("cambiato tab");
            if (this.tabLoaded==false)
                this.tabLoaded=true
            else
                this.renderGraph();
        },
        accettaInvitoPendente() {
            this.$store.state.loading = true;
            this.$store.state.commandResponse.command = '';
            this.$store.state.invite = this.invitoPendente.invite_id;
            this.$store.state.inviteType = this.invitoPendente.role;
            let self = this;
            window.setTimeout(function() {self.$store.state.loading = false},2000);
        },
         formatDate(date) {
            var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        },
        passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        }
    }
}
</script>

